/**
 * Container for the priority list: maps the dashboard status foundation items
 * to rows. The status query is owned by `DashboardOverview` so the cards, the
 * priority list and today's-status all read one response and reconcile.
 */

import { useMemo } from "react";

import type { DashboardStatusItemDto } from "@/generated/model";
import {
  mapToPriorityRows,
  type PriorityLink,
} from "@/lib/dashboard/priority-list";

import { PriorityList } from "./PriorityList";

interface PriorityListSectionProps {
  items: DashboardStatusItemDto[];
  loading: boolean;
  onOpen: (link: PriorityLink) => void;
  onViewAll: () => void;
}

export function PriorityListSection({
  items,
  loading,
  onOpen,
  onViewAll,
}: PriorityListSectionProps) {
  const rows = useMemo(() => mapToPriorityRows(items), [items]);

  return (
    <PriorityList
      rows={rows}
      loading={loading}
      onOpen={onOpen}
      onViewAll={onViewAll}
    />
  );
}
